module.exports = __webpack_public_path__ + "media/assets/bookshelf-skeleton-b2fada7c151270a6a1e18a4e4e84c8a0.svg";